// Third-party
import React, { Component } from 'react';

// Utils
import { truncateString } from '../../../../../utils/objects';
import { FormattedMessage } from '../../../../../utils/i18n';

// Components
import { PrimaryButton } from '../../../../components/buttons';
import { RiskProfileCard } from '../../../../components/common';
import { RiskProfileEmptyState } from '../../../../components/risk-profiles';
import User from '@/types/user';
import GenericContact from '@/types/generic-contact';
import Locale from '@/types/locale';
import ContactRiskProfile from '@/types/contact-risk-profile';
import KycQuestionnaire from '@/types/kyc-questionnaire';

type Props = {
  user: User;
  contact: GenericContact;
  riskProfiles: ContactRiskProfile[];
  locale: Locale;
  loading: boolean;
  onAttachRiskProfile: (profile: ContactRiskProfile) => void;
  onDeleteRiskProfile: (profile: ContactRiskProfile) => void;
  onEditRiskProfile: (profile: ContactRiskProfile) => void;
  onCreateRiskProfile: (questionnaire?: KycQuestionnaire) => void;
  selectedRiskProfileForComparison?: ContactRiskProfile;
};
// Legacy component - Use ContactDetailsRiskProfiles for light mode
export default class ContactRiskProfiles extends Component<Props> {
  renderRiskProfile = (profile: ContactRiskProfile) => {
    const { locale, user, loading, selectedRiskProfileForComparison } = this.props;
    const canDelete = profile.availableActions == null || profile.availableActions.delete;
    const canEdit = profile.availableActions == null || profile.availableActions.edit;

    const onDelete = canDelete ? () => this.props.onDeleteRiskProfile(profile) : undefined;
    const onEdit = canEdit ? () => this.props.onEditRiskProfile(profile) : undefined;

    return (
      <RiskProfileCard
        key={profile._id}
        riskProfile={profile.profile}
        locale={locale}
        user={user}
        loading={loading}
        selectedRiskProfile={selectedRiskProfileForComparison?.profile}
        onAttach={() => this.props.onAttachRiskProfile(profile)}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    );
  };

  renderRiskProfiles = () => {
    const { riskProfiles } = this.props;

    return <div className="risk-profiles-list">{riskProfiles.map(profile => this.renderRiskProfile(profile))}</div>;
  };

  renderEmptyState = () => {
    const { user, contact } = this.props;

    return <RiskProfileEmptyState user={user} contact={contact} onCreateRiskProfile={this.onCreateNewProfile} />;
  };

  onCreateNewProfile = () => {
    this.props.onCreateRiskProfile();
  };

  renderContent = () => {
    const { contact } = this.props;

    if (!contact.riskProfiles || contact.riskProfiles.length === 0) {
      return this.renderEmptyState();
    }

    return this.renderRiskProfiles();
  };

  render() {
    const { contact, loading } = this.props;

    return (
      <div className="contact-risk-profiles">
        <div className="content-header">
          <h1 data-private data-dd-privacy="mask">
            <FormattedMessage id="Contacts.ContactTabs.RiskProfiles.Header" values={{ name: truncateString(contact.fname || '', 80) }} />
          </h1>

          <div className="content-actions">
            <PrimaryButton disabled={loading} icon="plus" onClick={this.onCreateNewProfile}>
              <FormattedMessage id="Contacts.ContactTabs.RiskProfiles.AddRiskProfile" />
            </PrimaryButton>
          </div>
        </div>

        {this.renderContent()}
      </div>
    );
  }
}
